import { RouteObject } from "react-router-dom";
import { GeneralErrorPage } from "@songtradr-sso/shared/frontend";
import { EmailConfirmation } from "./EmailConfirmation";
import { routes } from "./EmailConfirmation.Parts";

// LOADER

// WRAPPER

// ROUTE
export const EmailConfirmationRouteObject: RouteObject = {
  path: routes.confirmEmail,
  errorElement: <GeneralErrorPage />,
  Component: EmailConfirmation,
};
